import * as React from "react";
const SvgFiBrands3M = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="m18.905 5.972-1.733 7.053-1.739-7.053h-5.099v2.605c-.612-2.28-2.773-2.85-4.774-2.883C3.121 5.662.564 6.718.47 9.944h3.374c0-.974.747-1.53 1.588-1.518 1.033-.008 1.509.433 1.533 1.12-.036.596-.388 1.011-1.525 1.011H4.306v2.341h1.031c.584 0 1.399.318 1.431 1.151.039.993-.652 1.43-1.502 1.438-1.517-.056-1.763-1.222-1.763-2.224H0c.016.675-.151 5.075 5.337 5.043 2.629.024 4.464-1.08 5.004-2.605v2.335h3.455v-7.609l1.867 7.61h3.018l1.874-7.602v7.61H24V5.971zm-8.562 7.037c-.429-.89-1.034-1.279-1.376-1.402.715-.318 1.09-.749 1.376-1.608z"
    />
  </svg>
);
export default SvgFiBrands3M;
